<h3>
    <a ng-click="viewDetails($event, item)">
        {{ item.name }}<span ng-if="!item.isActive"> {{'centuriList.inactive'|translate}}</span>
    </a>
</h3>